import React from 'react';
export var ExternalIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16", width: "16", height: "16" },
    React.createElement("rect", { width: "16", height: "16", fill: "none" }),
    React.createElement("path", { d: "M14,14H2V2H8V0H0V16H16V7.966H14Z", fill: "#4997c7" }),
    React.createElement("path", { d: "M9.984,0V2h2.6L5.893,8.693l1.414,1.414L14,3.414V6h2V0Z", fill: "#4997c7" }))); };
//# sourceMappingURL=ExternalIcon.js.map